import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/Logo.png"
import '../Styles.css'

const CourseHeader = () => {
    return (
        <nav className="navbar-courses">
            <div className="container">
                <div className="logo">
                    <Link to="/"><img src={logo} className='logo-img' alt="#" /></Link>
                    <Link to="/" className='interncrafters'><h4>Intern Crafters</h4></Link>
                </div>
            </div>
        </nav>
    )
}

export default CourseHeader
